import React, { useState, useCallback, memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ScreenLockRotationSharpIcon from '@mui/icons-material/ScreenLockRotationSharp';
import DataTransportDropdown from 'pages/OcplcEditDashboard/OcplcWorkSpaceButtons/dataTransport';
import Box from '@mui/material/Box';
import UploadDialog from '../OcplcDialog/UploadDialogOcplc';
import DownloadDialog from '../OcplcDialog/DownloadDialogOcplc';
import { useStyles } from '../../ocplcDashboard/ocplcHelpers';
import { filterByStatus } from 'actions/ocplcAction';
import { iconButtonStyle } from 'pages/DashboardHelpers';
import { DASHBOARD_TITLE, LOAD_COUNT, MATERIAL_AVAILABILITY, OCPLC_ADMIN, OCPLC_READ_ONLY, OCPLC_REGIONAL, PLC_ADMIN, PLC_WW, ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE, VERSION_0002, VERSION_0003 } from 'constants/ocplcConstants';
import { StartOver } from './startOver';
import LockAndDownloadDialog from '../OcplcDialog/lockAndDownloadDialog';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { IconButton, Tooltip } from '@mui/material';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import { ButtonSpinner } from 'components/ButtonSpinner';

const UploadDownloadDataTransIcons = memo(({ tableData, kmatId, selectKmat, productGroup, productLineID, title, version, selectedTable, disabled, userRole, region, dashboardrole, assignedRole, checkedRows, userEmail, setCheckedRows, ocplcAdmin, selectedCategory, selectedProductGroup ,selectedIds, setSelectedIds}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [dialogState, setDialogState] = useState({ upload: false, download: false, lockanddownload: false });
    const [isloading,setisLoading] = useState(false);

    const disableDownload = disabled 
    || checkedRows.length === 0 
    || checkedRows.some(row => row.status === "New");


    const handleDialogClose = useCallback(() => {
        setDialogState({ upload: false, download: false });
    }, []);

    const handleUploadPlc = () => setDialogState(prevState => ({ ...prevState, upload: true }));
    const handleDownloadPlc = () => {
      if (checkedRows.length > LOAD_COUNT && isDashboard) {
          setDialogState({ type: 'exceedLoadCount', open: true });
      } else {
          setDialogState(prevState => ({ ...prevState, download: true }));
      }
    };

    const handleCancelClick = () => {
        setDialogState({ upload: false, download: false, lockanddownload: false, open: false, type: '' });
    };
    const handleLockAndDownload = () => setDialogState(prevState => ({ ...prevState, lockanddownload: true }));



    const handleRecentUpdates = useCallback(() => {
        dispatch(filterByStatus({ statusList: ["P", "M"], selectedTable }));
        handleDialogClose();
        setCheckedRows([]);
        setSelectedIds([]);
    }, [ selectedTable]);

    const isDashboard = title === DASHBOARD_TITLE;
    const inViewRecord = version === VERSION_0003;
    const isEditPage = version === VERSION_0002;
    const showLockandDownload = selectedTable === MATERIAL_AVAILABILITY && isEditPage;
    const showUpload = selectedTable === MATERIAL_AVAILABILITY && isEditPage;
    const isAssignedRoleAdmin = assignedRole === ROLE_NAME_FOR_ADMIN;
    const hasSelectedRows = checkedRows.length === 0;
    const isDisabled = disabled || (isEditPage && !isAssignedRoleAdmin) || inViewRecord || hasSelectedRows;
    const isDashboradDTDisabled = disabled || dashboardrole !== PLC_ADMIN;
    const isRegionalAndReadOnly = [OCPLC_REGIONAL, OCPLC_READ_ONLY].includes(assignedRole);
    const hasLogicalLock = checkedRows.some(row => row.logicalLock === 0);
    const lockAndDownloadDisabled = hasSelectedRows || isRegionalAndReadOnly || !hasLogicalLock;
    const uploadDisabled = isRegionalAndReadOnly || hasLogicalLock || hasSelectedRows;
    const isOcplcConfig = selectedTable === "OCPLC Configuration";

    return (
      <Box sx={{ display: "flex" }}>
        {title === "ocplcEdit" && (
          <StartOver
            kmatId={kmatId}
            ocplcAdmin={ocplcAdmin}
            userEmail={userEmail}
            isEditPage={isEditPage}
          />
        )}
        { !isOcplcConfig && (
        <Tooltip title="Download">
          <span>
            <IconButton
              sx={{ ...iconButtonStyle }}
              onClick={handleDownloadPlc}
              disabled={disableDownload}
              size="large"
              color="primary"
            >
              <FileDownloadOutlinedIcon />
            </IconButton>
          </span>
        </Tooltip>
        )}
        {showLockandDownload && (
          <Tooltip title="Lock and Download">
            <span>
              <IconButton
                sx={{ ...iconButtonStyle }}
                onClick={handleLockAndDownload}
                disabled={lockAndDownloadDisabled}
                size="large"
                color="primary"
              >
                <ScreenLockRotationSharpIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {showUpload && (
          <Tooltip title="Upload">
            <span>
              <IconButton
                sx={{ ...iconButtonStyle }}
                onClick={handleUploadPlc}
                disabled={uploadDisabled}
                size="large"
                color="primary"
              >
                <FileUploadOutlinedIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {!isOcplcConfig && (
        <DataTransportDropdown
          dashboardDTDisabled={isDashboradDTDisabled}
          userEmail={userEmail}
          setCheckedRows={setCheckedRows}
          checkedRows={checkedRows}
          tableData={tableData}
          version={version}
          disabled={isDisabled}
          userRole={userRole}
          region={region}
          assignedRole={assignedRole}
          selectKmat={selectKmat}
          selectedCategory={selectedCategory}
          productGroup={productGroup}
          productLineID={productLineID}
          ocplcAdmin={ocplcAdmin}
          selectedTable={selectedTable}
          selectedProductGroup={selectedProductGroup}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          setisLoading={setisLoading}
          isLoading={isloading}
        />
        )}

        {title === "ocplcEdit" && !isOcplcConfig && (
          <Tooltip title="Recent Updates">
            <span>
              <IconButton
                sx={{ ...iconButtonStyle }}
                onClick={handleRecentUpdates}
                size="large"
                color="primary"
              >
                <WorkHistoryIcon htmlColor="#0278AB" />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {dialogState.upload && (
          <UploadDialog
            open={dialogState.upload}
            setOpen={setDialogState}
            handleClose={handleDialogClose}
            checkedRows={checkedRows}
            selectedCategory={selectedCategory}
            selectKmat={selectKmat}
            productGroup={productGroup}
            region={region}
            setCheckedRows={setCheckedRows}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
        )}

        { isloading ? <ButtonSpinner/> : (
          dialogState.download &&(
            <DownloadDialog
            open={dialogState.download}
            setOpen={setDialogState}
            handleClose={handleDialogClose}
            checkedRows={checkedRows}
            productLineID={productLineID}
            setCheckedRows={setCheckedRows}
            region={region}
            selectKmat={selectKmat}
            title={title}
            selectedTable={selectedTable}
            selectedCategory={selectedCategory}
            dashboardrole={dashboardrole}
            productGroup={productGroup}
            selectedProductGroup={selectedProductGroup}
            setisLoading={setisLoading}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
          )
        )}

        {dialogState.open && dialogState.type === "exceedLoadCount" && (
          <ConfirmationDialog
            open={dialogState.open}
            onClose={handleCancelClick}
            content={`You cannot select more than ${LOAD_COUNT} items for Download`}
            bgColor="#0278ab"
          />
        )}
        
        { isloading ? <ButtonSpinner/> : (
          dialogState.lockanddownload && (
          <LockAndDownloadDialog
            open={dialogState.lockanddownload}
            setOpen={setDialogState}
            handleClose={handleDialogClose}
            checkedRows={checkedRows}
            setCheckedRows={setCheckedRows}
            region={region}
            loginUserEmailId={userEmail}
            selectedCategory={selectedCategory}
            selectKmat={selectKmat}
            productGroup={productGroup}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            setisLoading={setisLoading}
          />
        ))}
      </Box>
    );
});

export default UploadDownloadDataTransIcons;
